export type StaffRole = 'Owner' | 'Manager' | 'Technician' | 'SeniorTechnician' | 'ServiceAdvisor' | 'PartClerk' | 'Receptionist' | 'Apprentice' | 'Student' | 'Intern';

export function isOwnerOrSolo(role: string | null): boolean {
  return role === null || role === 'Owner';
}

export function isManagerOrAbove(role: string | null): boolean {
  return role === null || role === 'Owner' || role === 'Manager';
}

export function isTechnician(role: string | null): boolean {
  return role === 'Technician' || role === 'SeniorTechnician' || role === 'Apprentice' || role === 'Student' || role === 'Intern';
}

export function canViewFinancials(role: string | null): boolean {
  return isManagerOrAbove(role);
}

export function canViewBilling(role: string | null): boolean {
  return isManagerOrAbove(role);
}

export function canManageStaff(role: string | null): boolean {
  return isManagerOrAbove(role);
}

export function canSetStaffPassword(role: string | null): boolean {
  return isOwnerOrSolo(role);
}

export function canGenerateTechnicianPin(role: string | null): boolean {
  return isOwnerOrSolo(role);
}

export function canManageSettings(role: string | null): boolean {
  return isManagerOrAbove(role);
}

export function canManageIntake(role: string | null): boolean {
  return role === 'Owner' || role === 'Manager' || role === 'ServiceAdvisor' || role === 'Receptionist';
}

export function canDeleteCustomer(role: string | null): boolean {
  return isOwnerOrSolo(role);
}

export function canDeleteInventory(role: string | null): boolean {
  return isManagerOrAbove(role);
}

export function getRoleLabel(role: string | null): string {
  return role ?? 'Owner';
}

export function getRoleBadgeColor(role: string | null): 'default' | 'success' | 'info' | 'warning' | 'danger' | 'neutral' {
  switch (role) {
    case 'Owner':
      return 'default';
    case 'Manager':
      return 'success';
    case 'Technician':
    case 'SeniorTechnician':
      return 'info';
    case 'Apprentice':
    case 'Student':
    case 'Intern':
      return 'warning';
    case 'ServiceAdvisor':
      return 'warning';
    case 'PartClerk':
    case 'Receptionist':
      return 'neutral';
    default:
      return 'default';
  }
}
